import { render } from "./ShortForm.vue?vue&type=template&id=b20fe906&scoped=true"
import script from "./ShortForm.vue?vue&type=script&lang=js"
export * from "./ShortForm.vue?vue&type=script&lang=js"

import "./ShortForm.vue?vue&type=style&index=0&id=b20fe906&scoped=true&lang=scss"

import exportComponent from "D:\\work\\feedback_page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b20fe906"]])

export default __exports__